// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Employee_wrapper__uF9CO","avatar":"Employee_avatar__wK4aC","info":"Employee_info__H91SC","position":"Employee_position__cUO5v","link":"Employee_link__AMq4f"};